// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
function ProductsCount(Props) {
  var category = Props.category;
  var className = Props.className;
  var format = Props.format;
  var match = RouterProvider$Showside.useRouter(undefined);
  var favorites = Favorites$Showside.useFavorites(undefined);
  var match$1 = UserSavedProductsProvider$Showside.use(undefined);
  var defaultFormat = function (prim) {
    return String(prim);
  };
  var format$1 = Belt_Option.getWithDefault(format, defaultFormat);
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var match$3 = match$2.config;
  var account = match$3.transitiveAccount;
  var match$4 = EntrypointContext$Showside.use(undefined);
  var defaultFilters = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var match$5 = UseApi$Showside.useCategoryProducts(undefined, match$3.transitiveStoreId, category.id, Category$Showside.ExternalConnection.getStoreCategoryConnection(category), match$3.settings.hideOutOfStock, match.productFilters, defaultFilters, undefined, match.productSort, true, match$4.smartnavApiHost, undefined, match$4.market, undefined);
  var totalValue = Belt_Option.flatMap(Belt_Option.flatMap(match$5.swr.data, function (data) {
    return Belt_Array.get(data, 0);
  }), function (page) {
    return page.total;
  });
  var match$6 = Category$Showside.ExternalConnection.getConnection(category);
  var totalValue$1;
  if (match$6 !== undefined && typeof match$6 === "number") {
    switch (match$6) {
      case /* History */0:
        totalValue$1 = match$1.history.value.length;
        break;
      case /* Favorites */1:
        totalValue$1 = favorites.count;
        break;
      case /* StoreCart */2:
        totalValue$1 = undefined;
        break;
    }
  } else {
    totalValue$1 = totalValue;
  }
  var match$7 = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  var fallbackCount = match$7 !== undefined ? match$7.count : Category$Showside.getProducts(category).length;
  var match$8 = React.useState(function () {
    return totalValue$1;
  });
  var setTotal = match$8[1];
  React.useEffect(function () {
    Curry._1(setTotal, function (previous) {
      return Belt_Option.orElse(totalValue$1, previous);
    });
  }, [totalValue$1]);
  var count = Belt_Option.getWithDefault(match$8[0], fallbackCount);
  return React.createElement("div", {
    className: Cn.make([Belt_Option.getWithDefault(className, ""), Belt_Option.isNone(totalValue$1) ? CSS$Showside.prefix("opacity-50") : ""])
  }, Curry._1(format$1, count));
}
ProductsCount.displayName = "ProductsCount";
var make = ProductsCount;
export { make };
/* react Not a pure module */